import React from 'react';
import { Image, StyleSheet, Text, View } from 'react-native';
import { useTranslation } from 'react-i18next';
import { Paprika } from '../../styles/theme';

const LOGO = require('../../../assets/brand/duchef-logo.png');

interface Props {
  variant?: 'phone' | 'rail';
  /** Sits at the end of the row — the quiz's « J'ai déjà un compte ». */
  trailing?: React.ReactNode;
}

/** The official Du Chef mark at the top of every onboarding screen. */
export function BrandRow({ variant = 'phone', trailing }: Props) {
  const { t } = useTranslation();
  const height = variant === 'rail' ? 46 : 32;
  return (
    <View style={styles.row} accessibilityRole="header" testID="onb-brand">
      <Image source={LOGO} style={{ height, width: height * (330 / 116) }} resizeMode="contain" accessibilityLabel={t('onboarding.brand')} />
      {trailing}
    </View>
  );
}

const styles = StyleSheet.create({
  row: { flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', gap: 8, paddingVertical: 4 },
  word: { fontFamily: 'Newsreader-Regular', fontSize: 18, color: Paprika.textPrimary },
});

export const brandWordStyle = styles.word;
export const brandText = (t: (k: string) => string) => <Text style={styles.word}>{t('onboarding.brand')}</Text>;
